import { createStore } from 'vuex'
import {useToast} from 'vue-toastification'
import user from "@/store/modules/user";
import storeGroups from "@/store/modules/storeGroups";
import suppliers from "@/store/modules/suppliers";
import tenders from "@/store/modules/tenders";
import managers from "@/store/modules/managers";
import categoryManagers from "@/store/modules/categoryManagers";
import categoryAdmins from "@/store/modules/categoryAdmins";
import products from "@/store/modules/products";
import delivery from "@/store/modules/delivery";
import ws from "@/store/modules/ws";
import stats from "@/store/modules/stats";
import schedules from "@/store/modules/schedules";
import notifications from "@/store/modules/notifications";

const toast = useToast()
export default createStore({
	state() {
		return {
			isLoading: false,
			loadingPool: new Set()
		}
	},
	mutations: {
		startLoading(state, name) {
			state.loadingPool.add(name)
			if (!state.isLoading) state.isLoading = true
		},
		stopLoading(state, name) {
			if (state.loadingPool.has(name)) {
				state.loadingPool.delete(name)
			} else {
				console.error(`${name} : не найдено в пуле загрузки`)
			}
			if (!state.loadingPool.size) {
				state.isLoading = false
			}
		}
	},
	actions: {
		showError(ctx, message='Ошибка') {
			toast.error(message)
		}
	},
	getters: {
		isLoading: state => state.isLoading,
		isActionPending(state) {
			return (actionName) => state.loadingPool.has(actionName);
		},
	},
	modules: {
		user,
		storeGroups,
		suppliers,
		managers,
		categoryManagers,
		categoryAdmins,
		tenders,
		products,
		delivery,
		ws,
		stats,
		notifications,
		schedules
	}
})

